import React from 'react';
import { MANTY_ORANGE } from 'styles/theme';
import InfoBox from 'ui/InfoBox/InfoBox';

type Props = {
    children: React.ReactNode;
};
export const ObsoleteInfoBox = ({ children }: Props) => {
    return (
        <InfoBox
            style={{
                color: MANTY_ORANGE,
                backgroundColor: 'rgba(233, 129, 95, 0.15)',
                border: `1px solid ${MANTY_ORANGE}`,
            }}
        >
            {children}
        </InfoBox>
    );
};
